/**
 * Injection-token wiring for API Repo.
 * This file defines shared dependency-injection bindings used by the platform layer.
 */
import { EnvironmentProviders, InjectionToken, inject, makeEnvironmentProviders } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { ApiRepository } from './api-repository';
import { HttpRepository } from './http.repository';
import { MockRepository } from './mock.repository';

export const API_REPO = new InjectionToken<ApiRepository>('API_REPO');

export function provideApiRepository(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: API_REPO,
      useFactory: () => {
        return environment.useMock ? inject(MockRepository) : inject(HttpRepository);
      }
    }
  ]);
}
